import React from 'react'
import { Row, Col } from 'react-bootstrap'

const Legal = () => (
  <Row componentClass="article">
    <Col componentClass="article" mdOffset={2} md={8} xs={12}>
      <h1>Terms Of Service</h1>
      <p>
        <font size="2">
          This website (<strong>www.carfinder.com</strong>) is an interactive
          online service operated by CarFinder.com, LLC (“carfinder.com”).
          CarFinder.com offers users information services and content provided
          by CarFinder.com and other information providers.
        </font>
      </p>

      <p>
        <strong>
          <font size="2">User Agreement.</font>
        </strong>
        <font size="2">
          {' '}
          In order to protect the interests of all of our users, as well as
          those of our information providers, we ask that you abide by the
          following rules. By registering as a user or by using{' '}
          <strong>www.carfinder.com</strong> (the “Service”), you hereby agree
          to be bound by all of the following terms and conditions (“Terms of
          Service” or “TOS”).
        </font>
      </p>

      <p>
        <strong>
          <font size="2">Termination of Service.</font>
        </strong>
        <font size="2">
          {' '}
          You understand and agree that in carfinder.com’s sole discretion, and
          without prior notice, carfinder.com may terminate your access to this
          website and the Service or exercise any other remedy available and
          remove any unauthorized User Content if carfinder.com believes that
          your use of the website, Service and/or any User Content you provided
          has violated or is inconsistent with these Terms of Service or has
          violated the rights of carfinder.com, another User or the law. You
          agree that monetary damages may not provide a sufficient remedy to
          carfinder.com for violations of these terms and conditions, and you
          consent to injunctive or other equitable relief for such violations.
          carfinder.com is not required to provide any refund to you if you are
          terminated as a User because you have violated these Terms of Service.
        </font>
      </p>

      <p>
        <strong>
          <font size="2">Copyright Notice and Limitations on Use.</font>
        </strong>
        <font size="2">
          All of the information, content and services (collectively, the
          “Content”) within this Service are protected by copyright and other
          intellectual property laws. The Content is owned by carfinder.com and
          its affiliated companies, licensors and suppliers. The Content is
          intended for personal use only. While you may interact with or
          download a single copy of any portion of the Content for your
          personal, noncommercial entertainment, information or use, you may not
          reproduce, sell, publish, distribute, modify, display, repost or
          otherwise use any portion of the Content in any other way or for any
          other purpose without the written consent of carfinder.com. Requests
          regarding use of the Content for any purpose other than personal,
          noncommercial use should be directed to Damon DeCastro,{' '}
        </font>{' '}
        <img
          align="left"
          title=""
          alt="email business support"
          border="0"
          src="/assets/img/cfemail_business_support.jpg"
        />
      </p>

      <p>
        <font size="2">
          <br />
          You acknowledge that the Content includes certain trademarks and
          service marks owned by carfinder.com,&nbsp; including the name “<strong
          >
            carfinder.com
          </strong>” and certain logotypes, as well as trademarks owned by other
          information providers. You agree not to copy, use or otherwise
          infringe upon these trademarks or service marks. You further agree
          that you will not alter or remove any trademark, copyright or other
          notice from any copies of the Content.
        </font>{' '}
      </p>

      <p>
        <font size="2">
          If you operate a website and wish to link to the Service, you must
          link to the Service’s home page unless permission otherwise has been
          granted in writing by carfinder.com Permissions. CarFinder.com
          reserves the right to reject or terminate any links to the Content or
          the Service.{' '}
        </font>{' '}
      </p>

      <p>
        <strong>
          <font size="2">Interactive Areas.</font>
        </strong>
        <font size="2">
          {' '}
          The Service’s forums, bulletin boards and chat rooms are provided to
          give users 18 years of age and older an interesting and stimulating
          forum in which they can express their opinions and share their ideas.
          CarFinder.com, does not endorse the accuracy or reliability of any
          advice, opinion, statement or information posted on these forums,
          message boards, bulletin boards or chat rooms. Please use your best
          judgment, and be respectful of other individuals using these forums.
          Do not use vulgar, abusive or hateful language. You may not use the
          Service’s message boards, bulletin boards or chat rooms for
          advertising or promotional materials or other forms of solicitation.
          Uploading copyrighted or other proprietary material of any kind on the
          Service without the express permission of the owner of that material
          is prohibited and may result in civil and/or criminal liability.
        </font>
      </p>

      <p>
        <font size="2">
          Given the nature of the Service and the volume of messages and
          postings, carfinder.com cannot and does not monitor all of the
          material posted or transmitted by users and third-party information
          providers. While you agree that carfinder.com will not be liable for
          such third-party content, carfinder.com reserves the right to delete,
          move or edit any communications or content that it deems in its sole
          discretion to be violative of this Term of Service; harmful to
          individuals or communities; obscene; defamatory; in violation of
          carfinder.com’s or any third-party’s rights; or otherwise
          unacceptable.
        </font>
      </p>

      <p>
        <strong>
          <font size="2">User Content.</font>
        </strong>
        <font size="2">
          {' '}
          By placing material on or communicating with the{' '}
          <strong>www.carfinder.com</strong>
          website and the Service, you hereby grant to carfinder.com and its
          partners and their affiliates and related entities (collectively, “the
          Partners”) the royalty-free, perpetual, irrevocable, nonexclusive
          right and license to use, copy, modify, display, distribute and
          reproduce all such materials in any form, media, software or
          technology of any kind now existing or developed in the future. You
          also agree to indemnify, defend and hold carfinder.com and the
          Partners harmless against any claims or costs, including attorneys’
          fees, arising from the use or distribution of those materials. You
          further grant carfinder.com and the Partners the right to use your
          name in connection with the reproduction or distribution of such
          material.
        </font>
      </p>

      <p>
        <strong>
          <font size="2">Prohibited Activities and Content.</font>
        </strong>
        <font size="2">
          The following is a partial list of the kinds of activities and content
          that are prohibited on or through the Service: (a) submitting content
          that is patently offensive to the online community, such as content
          that promotes racism, bigotry, hatred or physical harm of any kind
          against any group or individual; (b) engaging in activities or
          submitting content that could be harmful to minors; (c) engaging in
          activities or submitting content that harasses or advocates harassment
          of another person; (d) engaging in activities that involve the
          transmission of “junk mail” or unsolicited mass mailing or “spam”; (e)
          engaging in activities, or submitting content, or promoting
          information that is false or misleading or promotes illegal activities
          or conduct that is abusive, threatening, obscene, defamatory or
          libelous; (f) submitting content that contains restricted or password
          only access pages, or hidden pages or images; (g) submitting content
          that displays pornographic or sexually explicit material of any kind;
          (h) submitting content that provides instructional information about
          illegal activities such as making or buying illegal weapons, violating
          someone’s privacy, or providing or creating computer viruses; (i)
          engaging in activities or submitting content that solicits passwords
          or personally identifiable information for commercial or unlawful
          purposes from other users; and (j) engaging in commercial activities
          and/or sales without our prior written consent such as contests,
          sweepstakes, barter, advertising and pyramid schemes.
        </font>
      </p>

      <p>
        <strong>
          <font size="2">Access to the Service.</font>
        </strong>
        <font size="2">
          {' '}
          You agree that you will not: (a) use any robot, spider, other
          automatic device or manual process to monitor or copy web pages or the
          Content contained in the Service or for any other unauthorized purpose
          without our prior expressed written permission; (b) use any device,
          software or routine to interfere or attempt to interfere with the
          proper working of the Service and the carfinder.com website; and (c)
          take any action that imposes an unreasonable or disproportionately
          large load on CarFinder.com’s hardware and software infrastructure.
        </font>
      </p>

      <p>
        <font size="2">
          CarFinder.com does not accept unsolicited materials or ideas for use
          or publication in its programming or in other digital, electronic or
          print media except in connection with the forums, bulletin boards and
          chat rooms on the Service. CarFinder.com and the Partners shall not be
          responsible for the similarity of any of its content or programming in
          any media to materials or ideas transmitted to the Service.
        </font>
      </p>

      <p>
        <strong>
          <font size="2">Copyrights and Copyright Agents.</font>
        </strong>
        <font size="2">
          It is the policy of carfinder.com to respond to claims of intellectual
          property infringement. CarFinder.com will promptly process and
          investigate notices of alleged infringement and will take appropriate
          actions under the Digital Millennium Copyright Act, Title 17, United
          States Code, Section 512(c)(2) (“DMCA”) and other applicable
          intellectual property laws.{' '}
        </font>{' '}
      </p>

      <p>
        <font size="2">Please forward all inquiries to:</font>
      </p>
      <address>
        <p>
          <strong>
            <font size="2">CarFinder.com, LLC</font>
          </strong>
          <font size="2">
            <br />
            Attn: Damon DeCastro<br />
            <img
              align="left"
              alt="email business support"
              border="0"
              title=""
              src="/assets/img/cfemail_business_support.jpg"
            />
          </font>
          <br />
          <br />
        </p>
      </address>

      <p>
        <strong>
          <font size="2">CarFinder.com Disclaimer:</font>
        </strong>
        <font size="2">
          {' '}
          The information on vehicles provided in this Service is supplied by
          the seller or third parties, and carfinder.com and the Partners cannot
          and do not verify or warrant the accuracy or completeness of the
          information. The Service and materials contained herein are provided
          on an “as is,” “as available” basis, and carfinder.com and the
          Partners make no representations or warranties, expressed or implied,
          to any actual or prospective purchaser or owner of any vehicle as to
          the existence, ownership or condition of the vehicle, or as to the
          accuracy or completeness of any information about the vehicle
          contained in this Service. You acknowledge that any reliance upon any
          such materials shall be at your sole risk. CarFinder.com reserves the
          right, in its sole discretion, to correct any error or omission in any
          portion of the Service or materials. Any and all concerns, differences
          or discrepancies must be addressed with the seller prior to the sale
          of the vehicle. You agree to release, hold harmless and indemnify
          carfinder.com and the Partners from any and all liability arising from
          incorrect or incomplete information regarding any vehicle.
        </font>
      </p>

      <p>
        <font size="2">
          CarFinder.com and the Partners specifically disclaim any implied
          warranties, including the warranties of merchantability and fitness,
          for a particular purpose regarding any vehicle with information
          provided in this Service. All vehicles are subject to prior sales.
        </font>
      </p>

      <p>
        <strong>
          <font size="2">General Disclaimer and Limitation of Liability.</font>
        </strong>
        <font size="2">
          {' '}
          YOU EXPRESSLY AGREE THAT USE OF THE SERVICE IS AT YOUR OWN RISK.
          NEITHER <strong>CARFINDER.COM</strong>, NOR ANY OF ITS AFFILIATES,
          EMPLOYEES, AGENTS, PARTNERS, CONTENT PROVIDERS OR LICENSORS, MAKES ANY
          REPRESENTATIONS OR WARRANTIES OF ANY KIND REGARDING THE SERVICE, THE
          CONTENT, ANY ADVERTISING MATERIAL OR THE RESULTS THAT MAY BE OBTAINED
          FROM USE OF THE SERVICE. THE SERVICE IS PROVIDED ON AN “AS IS” BASIS,
          AND <strong>CARFINDER.COM</strong> AND THE PARTNERS SPECIFICALLY
          DISCLAIM ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING WITHOUT
          LIMITATION, WARRANTIES OF FITNESS FOR A PARTICULAR PURPOSE, WARRANTIES
          OF MERCHANTABILITY OR WARRANTIES AGAINST INFRINGEMENT.{' '}
        </font>{' '}
      </p>

      <p>
        <strong>
          <font size="2">CARFINDER.COM</font>
        </strong>
        <font size="2">
          , ITS AFFILIATES, EMPLOYEES, AGENTS, PARTNERS, CONTENT PROVIDERS AND
          LICENSORS SHALL IN NO EVENT BE LIABLE FOR ANY DAMAGES OR LOSSES,
          INCLUDING, WITHOUT LIMITATION, DIRECT, INDIRECT, CONSEQUENTIAL,
          SPECIAL, INCIDENTAL OR PUNITIVE DAMAGES, RESULTING FROM OR CAUSED BY
          THE SERVICE OR ITS CONTENT, INCLUDING, WITHOUT LIMITATION, LOSSES
          RELATED TO: YOUR USE OR INABILITY TO USE THE SERVICE; ANY ERRORS,
          OMISSIONS OR DEFECTS IN THE CONTENT; OR ANY INTERRUPTIONS, DELAYS IN
          TRANSMISSION OR COMPUTER VIRUSES. IN ANY EVENT, ANY LIABILITY OF
          <strong>CARFINDER.COM</strong>, ITS AFFILIATES, EMPLOYEES, AGENTS,
          PARTNERS, CONTENT PROVIDERS AND LICENSORS SHALL NOT EXCEED THE AMOUNT
          PAID BY YOU TO THE SERVICE IN THE 12 MONTHS PRIOR TO THE CLAIMED
          INJURY OR DAMAGE.{' '}
        </font>{' '}
      </p>

      <p>
        <strong>
          <font size="2">Miscellaneous.</font>
        </strong>
        <font size="2">
          {' '}
          CarFinder.com reserves the right at its discretion to change these
          Terms of Service and will notify users of any such changes by online
          postings. Your continued use of the Service after the posting of any
          amended Terms of Service shall constitute your agreement to be bound
          by any such changes. The Service may modify, suspend, discontinue or
          restrict the use of any portion of the Service, including the
          availability of any portion of the Content at any time, without notice
          or liability.
        </font>
      </p>

      <p>
        <font size="2">
          These Terms of Service will be governed by and construed in accordance
          with the laws of the State of New Jersey, without regard to its
          conflicts of law provisions. You hereby agree that any cause of action
          you may have with respect to the Service must be filed in the federal
          or state courts located in Somerset County, NJ, or the Federal court
          in Trenton, NJ, within one{' '}
        </font>
        <font size="2">
          year after the cause of action arises or the cause is barred.
        </font>
      </p>

      <p>
        <font size="2">
          IF YOU DO NOT AGREE TO THE TERMS STATED ABOVE OR TO ANY CHANGES THE
          SERVICE MAKES IN THESE TERMS, PLEASE EXIT THE SERVICE IMMEDIATELY.{' '}
        </font>
      </p>
    </Col>
  </Row>
)
export default Legal



// WEBPACK FOOTER //
// ./src/components/Legal.js